import React, { useState, useEffect, Component } from "react";
import Table from "react-bootstrap/Table";
import axios from "axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Container } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const headercolumns = [
  "Booking NO",
  "BL No",
  "Cost Amount",
  "Quote Amt",
  "Profit",
  "Select",
  "View",
  "Remark",
];

const BookingApproval = () => {
  const [baseUrl, setBaseUrl] = useState("http://mol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("approvals/booking");
  const [bookingList, setBookingList] = useState(undefined);
  const [selectedRows, setSelectedRows] = useState([]);
  const columns = [
    "BookingNo",
    "BLNo",
    "TotalCost",
    "TotalQuote",
    "Difference",
  ];

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}`)
      .then((response) => response.json())
      .then((data) => {
        console.log(data.app);
        setBookingList(data.app);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleCheckboxChange = (event, id) => {
    if (event.target.checked) {
      setSelectedRows([...selectedRows, id]);
    } else {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    }
  };

  const handleSave = async (event) => {
    event.preventDefault();
    if (selectedRows == "") {
      toast.error("Please Select Booking", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      const approvalStatus = { ApprovalStatus: 1 };
      axios
        .post(
          `${baseUrl}approvals/${selectedRows}/bookingapproval`,
          approvalStatus
        )
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleReject = async (event) => {
    event.preventDefault();
    if (selectedRows == "") {
      toast.error("Please Select Booking", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      const approvalStatus = { ApprovalStatus: 2 };
      axios
        .post(
          `${baseUrl}approvals/${selectedRows}/bookingapproval`,
          approvalStatus
        )
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Table className="mt-2" responsive hover size="sm" striped="columns">
          <thead>
            <tr>
              {columns !== null
                ? headercolumns.map((column) => (
                    <th className="text-center color-white" key={column.id}>
                      {column}
                    </th>
                  ))
                : ""}
            </tr>
          </thead>
          <tbody>
            {bookingList !== undefined ? (
              bookingList.map((row, index) => (
                // <tr key={row.id} onClick={() => setSelectedRow(index,row)}>
                <tr key={row.id}>
                  {columns.map((column) => (
                    <td className="text-center color-white" key={column}>
                      {row[column]}
                    </td>
                  ))}
                  <td className="text-center">
                    <input
                      inline
                      label="1"
                      name="group1"
                      type={"checkbox"}
                      className="text-center"
                      onChange={(event) => handleCheckboxChange(event, row.id)}
                    />
                  </td>
                  <td>
                    <Button className="ms-3" variant="primary" type="submit">
                      View
                    </Button>
                  </td>
                  <td>
                    <input type="text"></input>
                  </td>
                </tr>
              ))
            ) : (
              <div>Loading...</div>
            )}
          </tbody>
        </Table>
      </Row>
      <Row className="text-center">
        <Col className="text-end">
          <Button className="ms-3 p-2" variant="primary" onClick={handleSave}>
            Approve
          </Button>
          <Button className="ms-3 p-2" variant="primary" onClick={handleReject}>
            Reject
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default BookingApproval;
